import React, { useEffect, useState } from "react";
import { api } from "../utils/api";

const PROFILS = {
  modele: { label: "Modele", icon: "✨", color: "#0F6E56", bg: "#E1F5EE", border: "#1D9E75", desc: "Score eleve + CA eleve" },
  trafic_faible: { label: "Trafic faible", icon: "📍", color: "#854F0B", bg: "#FAEEDA", border: "#EF9F27", desc: "Score eleve + CA faible" },
  potentiel: { label: "Potentiel", icon: "🚀", color: "#185FA5", bg: "#E6F1FB", border: "#378ADD", desc: "Score faible + CA eleve" },
  prioritaire: { label: "Prioritaire", icon: "🚨", color: "#A32D2D", bg: "#FCEBEB", border: "#E24B4A", desc: "Score faible + CA faible" },
  sans_score: { label: "Sans audit", icon: "—", color: "#5F5E5A", bg: "#F1EFE8", border: "#B4B2A9", desc: "Pas encore inspecte" },
};

function fmt(d) { return d.toISOString().slice(0, 10); }
function fmtFR(s) { if (!s) return ""; const [y,m,d] = s.split("-"); return `${d}/${m}/${y}`; }
function daysBetween(a, b) { return Math.round((new Date(b) - new Date(a)) / (1000*60*60*24)) + 1; }

export default function DirectorDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [activeQuick, setActiveQuick] = useState("today");
  const [availableDates, setAvailableDates] = useState([]);

  useEffect(() => {
    api.getCommercialDashboard()
      .then(d => {
        setData(d); setLoading(false);
        if (d.available_dates && d.available_dates.length > 0) {
          setAvailableDates(d.available_dates);
          const latest = d.available_dates[0];
          setDateFrom(latest); setDateTo(latest);
          // Auto-reload with latest date
          if (d.selected_dates && d.selected_dates[0] !== latest) {
            api.getCommercialDashboardByDates([latest])
              .then(d2 => setData(d2))
              .catch(() => {});
          }
        }
      })
      .catch(e => { setError(e.message); setLoading(false); });
  }, []);

  function loadRange(from, to) {
    if (!from || !to || availableDates.length === 0) return;
    setLoading(true);
    const allDates = availableDates.filter(d => d >= from && d <= to);
    if (allDates.length === 0) {
      setData(prev => ({ ...prev, stores: [], summary: { total_ca: 0, total_tickets: 0, avg_panier: 0, nb_stores: 0 } }));
      setLoading(false); return;
    }
    api.getCommercialDashboardByDates(allDates)
      .then(d => { setData(d); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  }

  function setQuick(key) {
    if (availableDates.length === 0) return;
    setActiveQuick(key);
    const latest = availableDates[0];
    const oldest = availableDates[availableDates.length - 1];
    let from, to = latest;
    if (key === "today") { from = latest; }
    else if (key === "yesterday") { const idx = availableDates.indexOf(latest); from = availableDates[idx+1] || latest; to = from; }
    else if (key === "7d") { const d = new Date(latest); d.setDate(d.getDate()-6); from = fmt(d); }
    else if (key === "30d") { const d = new Date(latest); d.setDate(d.getDate()-29); from = fmt(d); }
    else if (key === "month") { from = latest.slice(0,7) + "-01"; }
    else if (key === "all") { from = oldest; }
    from = from < oldest ? oldest : from;
    setDateFrom(from); setDateTo(to);
    loadRange(from, to);
  }

  function applyRange() { setActiveQuick(""); loadRange(dateFrom, dateTo); }

  const stores = data?.stores || [];
  const summary = data?.summary || {};
  const days = dateFrom && dateTo ? daysBetween(dateFrom, dateTo) : 1;
  const profileCounts = {};
  stores.forEach(s => { profileCounts[s.profil] = (profileCounts[s.profil]||0)+1; });

  const QUICK_BTNS = [
    {key:"today",label:"Aujourd hui"},{key:"yesterday",label:"Hier"},
    {key:"7d",label:"7 derniers jours"},{key:"30d",label:"30 derniers jours"},
    {key:"month",label:"Ce mois"},{key:"all",label:"Tout"},
  ];
  const pillStyle = (active) => ({
    padding:"6px 16px",borderRadius:20,fontSize:13,fontWeight:500,cursor:"pointer",
    border:`0.5px solid ${active?"#185FA5":"var(--border)"}`,
    background:active?"#185FA5":"white",color:active?"#E6F1FB":"var(--muted)",
    transition:"all .12s",whiteSpace:"nowrap",
  });

  if (error) return <div className="empty-state"><div className="empty-state-icon">⚠️</div><h3>Erreur</h3><p>{error}</p></div>;

  return (
    <div>
      <div className="page-header">
        <h1>Dashboard Directeur</h1>
        <p>Analyse croisee performance terrain x commercial</p>
      </div>

      <div className="card" style={{marginBottom:20,padding:"16px 20px"}}>
        <div style={{fontSize:11,fontWeight:600,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".06em",marginBottom:12}}>Periode</div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:14}}>
          {QUICK_BTNS.map(b => <button key={b.key} onClick={() => setQuick(b.key)} style={pillStyle(activeQuick===b.key)}>{b.label}</button>)}
        </div>
        <div style={{height:0.5,background:"var(--border)",margin:"0 0 14px"}}/>
        <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
          <span style={{fontSize:13,color:"var(--muted)"}}>Du</span>
          <input type="date" value={dateFrom} onChange={e=>setDateFrom(e.target.value)}
            style={{fontSize:13,padding:"6px 10px",borderRadius:8,border:"0.5px solid var(--border)",background:"white",color:"var(--text)"}}/>
          <span style={{fontSize:13,color:"var(--muted)"}}>au</span>
          <input type="date" value={dateTo} onChange={e=>setDateTo(e.target.value)}
            style={{fontSize:13,padding:"6px 10px",borderRadius:8,border:"0.5px solid var(--border)",background:"white",color:"var(--text)"}}/>
          <button onClick={applyRange}
            style={{padding:"6px 16px",borderRadius:8,border:"0.5px solid var(--border)",fontSize:13,fontWeight:500,cursor:"pointer",background:"white",color:"var(--text)"}}>
            Appliquer
          </button>
          {dateFrom && dateTo && (
            <div style={{marginLeft:"auto",display:"flex",alignItems:"center",gap:8,fontSize:13}}>
              <span style={{color:"var(--muted)"}}>{dateFrom===dateTo?fmtFR(dateFrom):`${fmtFR(dateFrom)} → ${fmtFR(dateTo)}`}</span>
              <span style={{padding:"3px 10px",borderRadius:20,fontSize:12,fontWeight:500,background:"#E6F1FB",color:"#185FA5"}}>{days} jour{days>1?"s":""}</span>
            </div>
          )}
        </div>
      </div>

      {loading ? (
        <div className="empty-state"><div className="empty-state-icon">📊</div><h3>Chargement...</h3></div>
      ) : (
        <>
          <div className="stat-grid" style={{marginBottom:20}}>
            <div className="stat-card blue"><div className="stat-value">{summary.total_ca?.toLocaleString("fr")} <span style={{fontSize:14}}>TND</span></div><div className="stat-label">CA total</div></div>
            <div className="stat-card green"><div className="stat-value">{summary.total_tickets?.toLocaleString("fr")}</div><div className="stat-label">Tickets</div></div>
            <div className="stat-card orange"><div className="stat-value">{summary.avg_panier} <span style={{fontSize:14}}>TND</span></div><div className="stat-label">Panier moyen</div></div>
            <div className="stat-card blue"><div className="stat-value">{summary.nb_stores}</div><div className="stat-label">Boutiques</div></div>
          </div>

          {Object.values(profileCounts).some(v=>v>0) && (
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit, minmax(150px, 1fr))",gap:10,marginBottom:20}}>
              {Object.entries(PROFILS).filter(([k])=>profileCounts[k]).map(([key,p])=>(
                <div key={key} style={{background:p.bg,borderRadius:10,padding:"12px 14px",borderLeft:`3px solid ${p.border}`}}>
                  <div style={{fontSize:24,fontWeight:500,color:p.color}}>{profileCounts[key]}</div>
                  <div style={{fontSize:13,fontWeight:500,color:p.color,marginTop:2}}>{p.icon} {p.label}</div>
                  <div style={{fontSize:11,color:p.color,marginTop:2,opacity:.75}}>{p.desc}</div>
                </div>
              ))}
            </div>
          )}

          <div className="card" style={{padding:0,overflow:"hidden"}}>
            <div style={{padding:"12px 16px",borderBottom:"1px solid var(--border)",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <span style={{fontWeight:600,fontSize:14,color:"var(--navy)"}}>Analyse par boutique</span>
              <span style={{fontSize:12,color:"#185FA5",background:"#E6F1FB",padding:"3px 10px",borderRadius:20,fontWeight:500}}>{stores.length} boutiques</span>
            </div>
            <div className="action-table-wrapper">
              <table className="data-table">
                <thead><tr><th>Boutique</th><th>Score</th><th>CA</th><th>Tickets</th><th>Panier moy.</th><th>UPT</th><th>Profil</th></tr></thead>
                <tbody>
                  {stores.map((s,i)=>{
                    const p=PROFILS[s.profil]||PROFILS.sans_score;
                    const sc=s.score!==null&&s.score!==undefined;
                    const scoreColor=sc?(s.score>=90?"#27500A":s.score>=75?"#0C447C":s.score>=50?"#633806":"#791F1F"):null;
                    const scoreBg=sc?(s.score>=90?"#EAF3DE":s.score>=75?"#E6F1FB":s.score>=50?"#FAEEDA":"#FCEBEB"):null;
                    return <tr key={i}>
                      <td style={{fontWeight:500}}>{s.store_name}</td>
                      <td>{sc?<span style={{background:scoreBg,color:scoreColor,padding:"2px 8px",borderRadius:10,fontSize:12,fontWeight:500}}>{s.score}</span>:<span style={{color:"var(--muted)"}}>—</span>}</td>
                      <td style={{fontWeight:500}}>{s.ca?.toLocaleString("fr")} <span style={{fontSize:11,color:"var(--muted)"}}>TND</span></td>
                      <td>{s.tickets}</td>
                      <td>{s.panier_moyen} <span style={{fontSize:11,color:"var(--muted)"}}>TND</span></td>
                      <td>{s.upt}</td>
                      <td><span style={{background:p.bg,color:p.color,padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:500,whiteSpace:"nowrap"}}>{p.icon} {p.label}</span></td>
                    </tr>;
                  })}
                  {stores.length===0&&<tr><td colSpan={7} style={{textAlign:"center",padding:24,color:"var(--muted)"}}>Aucune donnee pour cette periode</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
